import { useState } from 'react'
import { sounds } from '../utils/sounds'

export function SoundToggle() {
  const [enabled, setEnabled] = useState(sounds.isSoundsEnabled())

  const toggleSound = () => {
    const newState = sounds.toggleSounds()
    setEnabled(newState)
    // Play a sound to demonstrate
    if (newState) {
      sounds.click()
    }
  }

  return (
    <button
      className="theme-toggle"
      onClick={toggleSound}
      aria-label={`Sound ${enabled ? 'on' : 'off'}`}
      title={`Sound ${enabled ? 'on' : 'off'}`}
      style={{ right: '80px' }}
    >
      {enabled ? '🔊' : '🔇'}
    </button>
  )
}
